// extracted by mini-css-extract-plugin
export const root = "map-module--root--1DLvw";
export const image = "map-module--image--11Y6W";
export const button = "map-module--button--3u6iH";